var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReverse({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 18 18",
    width: 18,
    height: 18,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.571 9a.643.643 0 111.286 0 5.125 5.125 0 001.506 3.637A5.125 5.125 0 009 14.143a5.125 5.125 0 003.637-1.506.643.643 0 11.909.909A6.41 6.41 0 019 15.429a6.41 6.41 0 01-4.546-1.883A6.41 6.41 0 012.571 9zm11.572 0a5.125 5.125 0 00-1.506-3.637A5.125 5.125 0 009 3.857a5.125 5.125 0 00-3.637 1.506.643.643 0 11-.909-.909A6.41 6.41 0 019 2.571a6.41 6.41 0 014.546 1.883A6.41 6.41 0 0115.429 9h1.282c.073 0 .145.025.203.07.14.111.163.314.05.452l-1.924 2.379a.328.328 0 01-.508 0l-1.925-2.379a.32.32 0 01-.071-.2c0-.178.145-.322.325-.322h1.282zM1.036 8.478L2.96 6.099a.328.328 0 01.508 0l1.925 2.379c.112.138.09.34-.05.451a.328.328 0 01-.204.07H1.29a.323.323 0 01-.325-.32.32.32 0 01.072-.201z",
    id: "a"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReverse);
export default __webpack_public_path__ + "static/media/reverse.70762eb1db892ad097a5e799871afe51.svg";
export { ForwardRef as ReactComponent };